<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-row align="center" justify="center">
        <v-col cols="12" md="4">
          <v-data-table
            v-model="selected"
            :mobile-breakpoint="mobilebreakpoint"
            :headers="headers"
            :items="listingData"
            :items-per-page="-1"
            :search="search"
            item-key="ciR_INST_DT"
            class="elevation-4 mt-2"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
            show-select
            @item-selected="doTotal"
            @toggle-select-all="selectAllToggle"
          >
            <template
              v-slot:item.data-table-select="{ item, isSelected, select }"
            >
              <v-simple-checkbox
                :ripple="false"
                :value="isSelected"
                :readonly="item.isCompulsary == 1"
                :disabled="item.isCompulsary == 1"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.balance="{ item }">
              <span>{{ formatNumber(item.balance) }}</span>
            </template>
            <template v-slot:item.ciR_INST_DT="{ item }">
              <span>{{ formatDate(item.ciR_INST_DT, "DD-MMM-YY") }}</span>
            </template>
            <template slot="body.append">
              <td colspan="2" class="py-3 font-weight-black total">
                <span>Total</span>
              </td>
              <td class="py-3 font-weight-black total">
                {{ formatNumber(doTotal()) }}
              </td>
            </template>
          </v-data-table>

          <v-btn
            class="my-3"
            dense
            color="primary"
            @click="DuePay"
            block
            :loading="tableLoading"
            rounded
            x-large
          >
            <v-icon> mdi-credit-card-outline </v-icon>
            &nbsp;Proceed To Pay {{ formatNumber(DueAmount) }}
          </v-btn>
        </v-col>
      </v-row>
      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
      <v-dialog v-model="dialogPay" max-width="400px">
        <v-card v-if="payData">
          <v-toolbar dense color="secondary" dark>Confirm</v-toolbar>
          <table id="customers">
            <tr>
              <th>
                First Name
              </th>
              
              <th>
                {{payData.firstName}}
              </th>
            </tr>
            <tr>
              <th>
                Last Name
              </th>
              
              <th>
                {{payData.lastName}}
              </th>
            </tr>
            <tr>
              <th>
                Phone No
              </th>
              
              <th>
                {{payData.phone}}
              </th>
            </tr>
            <tr>
              <th>
                Email
              </th>
              
              <th>
                {{payData.email}}
              </th>
            </tr>
            <tr>
              <th>
                Amount
              </th>
              
              <th>
                {{payData.strAmount}}
              </th>
            </tr>

          </table>

          <form action="https://test.payu.in/_payment" method="post">
            <input type="hidden" name="firstname" :value="payData.firstName" />
            <input type="hidden" name="lastname" :value="payData.lastName" />
            <input
              type="hidden"
              name="surl"
              value="http://43.242.215.24:1124/api/Fees/DonePaymentTest"
            />
            <input type="hidden" name="phone" :value="payData.phone" />
            <input type="hidden" name="key" :value="payData.key" />
            <input type="hidden" name="hash" :value="payData.hashData" />

            <input type="hidden" name="curl" value="http://43.242.215.24:1124/api/Fees/DonePaymentTest" />
            <input type="hidden" name="furl" value="http://43.242.215.24:1124/api/Fees/DonePaymentTest" />
            <input type="hidden" name="txnid" :value="payData.txnID" />
            <input
              type="hidden"
              name="productinfo"
              :value="payData.productInfo"
            />
            <input type="hidden" name="amount" :value="payData.strAmount" />
            <input type="hidden" name="email" :value="payData.email" />

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogPay = false"
                >Cancel</v-btn
              >
              <v-btn type="submit" text color="blue darken-1" value="submit" >Make Payment</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}

.subtotal {
  background-color: yellow;
}

#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}


#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  
  
}
</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";

import vconfirm from "@/components/v-confirm";

import { formatDate, formatNumber } from "../util/helpers";
import { showSnackbar } from "../util/globalActions";

export default {
  name: "DuePayTestView",
  components: { vconfirm },

  data: () => ({
    dialogPay: false,
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    selected: [],
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    DueAmount: 0,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    listingData: [],
    message: "",
    professors: [],
    payData: null,
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    disabledCount: 0,
    headers: [
      {
        text: "Installment Date",
        value: "ciR_INST_DT",
        width: "120px",
      },
      {
        text: "Balance",
        value: "balance",
        width: "150px",
        align: "right",
      },
    ],
  }),
  created() {
    //this.headers = [];
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatNumber,
    formatDate,
    selectAllToggle(props) {
      this.selected = [];
      const self = this;
      props.items.forEach((item) => {
        if (item.isCompulsary) {
          self.selected.push(item);
        }
        if (props.value) {
          self.selected.push(item);
        }
      });
    },

    showData() {
      const self = this;

      self.tableLoading = true;

      axios({
        url: self.apiUrl + "api/Fees/DuePay",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data;
          self.selected = self.listingData.filter(
            (item) => item.isCompulsary === 1
          );
          self.listingData.map((item) => {
            if (item.isCompulsary == 1) self.disabledCount += 1;
          });
          //self.doTotal();
          self.tableLoading = false;
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    DuePay() {
      const self = this;
      axios({
        url: self.apiUrl + "api/Fees/InitPaymentTest",
        method: "POST",
        data: { uTR8_DuePay: this.selected },
        responseType: "json",
      })
        .then(function(res) {
          self.payData = res.data;
          console.log(res);
          self.dialogPay = true;
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    doTotal() {
      this.DueAmount = this.selected.reduce(
        (a, b) => a + (b["balance"] || 0),
        0
      );
      return this.DueAmount;
    },
  },
};
</script>
